import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../redux/network/https";
import { endPoints, queryKeys } from "../../redux/network/constant";

export const useSaveKnowledgeItem = (teamId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await axiosInstance.post(endPoints.KnowledgeItems(teamId), payload);
      return data?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.KnowledgeItems(teamId) });
    },
  });
};

export const useKnowledgeSearch = (teamId, q, enabled = true) =>
  useQuery({
    queryKey: queryKeys.KnowledgeSearch(teamId, q || ""),
    queryFn: async () => {
      const { data } = await axiosInstance.get(endPoints.KnowledgeSearch(teamId), {
        params: { q },
      });
      return data?.data;
    },
    enabled: !!teamId && !!q && enabled,
    staleTime: 30 * 1000,
  });

export const useKnowledgeAnswer = (teamId) =>
  useMutation({
    mutationFn: async (payload) => {
      const { data } = await axiosInstance.post(endPoints.KnowledgeAnswer(teamId), payload);
      return data?.data;
    },
  });
